/**
 * Created by hao.cheng on 2017/4/16.
 */
import React from 'react';
import {Col,Row, Form, Icon, Input, Button, Checkbox, message } from 'antd';
import title from '@/style/imgs/all/title.png';
import BreadcrumbCustom from './BreadcrumbCustom';

const FormItem = Form.Item;

class Gywm extends React.Component {
    state = {
        active:1,
        orderActive:"",
        title:"",

    };
    render() {
        return (
            <div className="content-right">
                <BreadcrumbCustom first="飞马救援"  second="关于我们"  />
                <div> 
                        <Col>
                            <Col style={{width:"962px",paddingLeft:26,marginTop:46,height:650,background:"#fff",border:"1px solid #ccc"}}>
                                <Col style={{overflow:"hidden",paddingTop:46}}><img style={{float:"left",marginTop:6}} src={title} alt=""/><span style={{fontWeight:"bold",marginLeft:8,fontSize:18,color:"#282828",float:"left"}}>关于我们</span></Col>
                                <Col style={{borderBottom:"1px solid #ddd",marginTop:30,width:880}}></Col>
                                <Col style={{height:504,textAlign:"left",marginTop:40,lineHeight:"50px",fontSize:16,color:"#282828",paddingRight:48,overflow:"auto"}}>
                                    公司诞生于美丽的西子湖畔，是国内领先的互联网科技平台及线下实体融合的综合性互联网+汽车后市场企业。立志于科技兴业，以技术带动、领跑行业模式，以创新点燃、改革行业发展。使得每一位汽车用户拥有便捷、高效、舒适的出行体验。
                                    企业规模： 完成了全国 144 个大中城市的网点铺设，并在浙江省全境铺设了实体分公司。公司拥有9家分公司13个部门，在职员工260余人，近200台救援设备，横跨信息技术、金融租赁、新媒体运营、智能救援等行业领域。通过行业创新融合获得了最有效的企业业绩！并且是全国唯一一家以实体救援运营铺设全国救援信息技术平台的企业。
                                    过往： 公司的前身杭州必拯是一家以汽车道路救援为主体的汽车救援公司，得益于国家对互联网信息技术的发展支持，整合了浙江省数家实力型救援企业作为地区骨干，并且通过信息技术的运用，开发了自动化飞马智能救援的信息平台。通过对于飞马平台的运营，发展了全国百余城市救援供应商，并在15年国内首创汽车救援就近搜索、自动派遣、全程线路可视化、视频可视化等信息融合运用的场景。5年来公司的救援人经历了全国数十起的台风、冰冻、城市内涝、地震等自然灾害。在政府的引导下，客户单位的需求下通过飞马平台的创新、高效方案调动灾害地区的救援力量。有效的降低、减少了保险公司、广大车主的经济损失减少了车主的焦虑感，提升了保险公司、国家政府对于自然灾害的应急的民间形象，获得了大家的一致好评。为此公司凭借飞马平台信息技术的创新获得了杭州市政府雏鹰计划的第一团队的无偿资助、并开启了杭州市高新企业、浙江省高新企业、国家高新企业的审评。
                                    坚持： 人的信念来自对于创新、技术的痴迷，来自于科技带来的便捷、高效、卓著成就的快感。通过创新改革、引领行业。通过金融租赁设备打造了分享型救援服务，使得每一位对于救援使命有着天生使命感的人获得了优秀、先进的装备。并获自动获得来自于飞马平台的救援任务信息，可以快速的前往完成汽车救援服务。
                                    得益于飞马平台的技术信息融合发展，可以获得许许多多汽车后市场的触点，维修、保养、美容、交通整治、道路运输等等细分行业的衔接。特别是高效完成车主对于保险理赔、定损维修、4S店服务增值的需求。
                                    公司秉承“保证服务品质，满足客户需求 ”的服务理念，以诚信、安全、快捷为企精神，我们承诺全年365天，24小时全天候为您提供专业、高效、快捷的救援服务。
                                    目前公司无论在经营资质，经营规模，服务信誉等方面已成为同行业的领导品牌，公司更是全国汽车道路救援服务”百强”实体企业之一，飞马平台年救援案件量达到了55万次以上，位居浙江救援企业第一！同时飞马救援是中国汽车流通协会汽车俱乐部主要重点培养单位之一。<br/>
                                    <span style={{fontWeight:"bold"}}>公司理念</span> 微笑获得满意、勤奋获得尊重，活跃创新点燃企业持续发展的动力。<br/>

                                    24H救援电话：400-070-9995<br/>
                                    年检预约： 0571-88923865<br/>
                                    传真：     0571-88237550<br/>
                                    企业微信： YD85460909<br/>
                                    企业网站： www.feima666.com
                                    </Col>
                            </Col>
                        </Col>
                </div>
            </div>


        );
    }
}



export default Gywm;


// WEBPACK FOOTER //
// ./src/components/gywm.jsx